define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Registrar outro usuário",

    'incrowd_stats.num_responders': "{{num}} Profissionais Especializados em Saúde",
    'incrowd_stats.num_answers': "{{num}} Perguntas Respondidas",
    'incrowd_stats.time_to_complete': "{{num}} Minutos para Concluir Pesquisa Normal",

    // INCROWD
    'incrowd.about': "Sobre",
    'incrowd.contact': "Contato",
    'incrowd.press': "Imprensa",
    'incrowd.careers': "Carreiras",
    'incrowd.terms': "Termos",
    'incrowd.t_and_c': "Termos e Condições",
    'incrowd.faq': "Dúvidas Frequentes",
    'incrowd.privacy': "Privacidade",
    'incrowd.copyright': "{{year}} InCrowd Inc, Todos os Direitos Reservados",
    'incrowd.blog': "Blog",
    'incrowd.support': "Suporte",
    'incrowd.info.ios': "Você sabia que os médicos na rede InCrowd agora podem enviar questões diretamente para seus colegas? Tente agora utilizando o  <InCrowd iOS App>!",
    'incrowd.refer': "Gosta de responder nossas pesquisas? <Refer a friend> hoje para se juntar a nosso batalhão e ambos ganharão 10 USD (ou equivalente). Uma vez que seu colega responda uma pesquisa, ele também receberá um bônus!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Micropesquisas,",
    'getstarted.encourage.title.two': "influência massiva",
    'getstarted.encourage.subtitle': "Junte-se a milhares de profissionais da saúde qualificados influenciando no desenvolvimento de novos produtos e tratamentos para pacientes através de micropesquisas simples, pelas quais nós pagamos você!",
    'getstarted.encourage.redirect_to_solutions': "Não é profissional da saúde mas deseja saber mais sobre a InCrowd?",
    'getstarted.actions.title': "Você é um profissional de saúde qualificado?",
    'getstarted.actions.subtitle': "Inscreva-se hoje e comece a ganhar dinheiro para responder a micropesquisas focadas na saúde",
    'getstarted.button.continue': "Comece",
    'getstarted.referral': "Inscreva-se para ganhar dinheiro com pesquisas, além de seu bônus pela indicação de %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Precisamos de alguns detalhes seus para configurar sua conta.",
    'details.profile_details': "Detalhes do Perfil",
    'details.address_information': "Informações de Endereço",
    'details.professional_info': "Informações Profissionais",
    'details.heading.finally': "… e finalmente",
    'details.how_receive_surveys': "Como você gostaría de receber pesquisas?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "O básico",
    'professionchoice.encourage.subtitle': "Não encontrou sua profissão? Informe-nos <aqui> para garantir que você seja notificado quando adicionarmos sua profissão.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Quem é você?",
    'authentication.encourage.subtitle': "O InCrowd precisa verificar sua identidade, mas nunca revelaremos ou distribuiremos suas informações pessoais a terceiros.",
    'authentication.actions.select_notifications': "Selecione a forma que você prefere para receber nossas pesquisas",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Por favor, aguarde enquanto validamos suas informações",
    'validation.please_answer': "Por favor, responda às seguintes perguntas para nos ajudar a validar os seus dados pessoais",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Confirmação",
    'confirmation.validation_success.subtitle': "Seu cadastro está completo, bem-vindo à InCrowd! Você receberá a confirmação em breve por e-mail e/ou mensagem de texto. Obrigado por se juntar a nós!",
    'confirmation.validation_error.title': "Precisamos de informações adicionais",
    'confirmation.validation_error.subtitle': "Desculpe, %{userFirstName}, houve um problema ao validarmos seus dados pessoais ",
    'confirmation.actions_title': "E agora?",
    'confirmation.go_to_your_profile': "Vá até o seu perfil",
    'confirmation.validation_success.actions_subtitle': "Você começará a receber nossas micropesquisas de 3 - 5 minutos em alguns dias, por e-mail ou mensagem de texto. Ainda não optou por receber pesquisas por mensagem de texto? Você pode alterar suas configurações de comunicação a qualquer momento em seu InCrowd perfil.",
    'confirmation.validation_error.actions_subtitle': "Use a janela pop-up de bate-papo no canto inferior direito da tela para falar com um membro da equipe InCrowd e discutir quaisquer questões pendentes.",
    'confirmation.referral.info.1': "Dentro de %{payoutBusinessDays} dias úteis depois de você preencher uma segunda pesquisa, você e a pessoa que te indicou <cada um receberá %{currency}% {referralBonusAmount}>. O %{currency}%{referralBonusAmount} será adicionado à sua conta de recompensas. Você pode acessar seu <perfil> quando quiser para atualizar preferências, verificar suas recompensas ou acessar quaisquer pesquisas abertas para às quais você tenha sido convidado.",
    'confirmation.referral.info.2': "Perguntas? <Fale conosco>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Você se qualifica?",
    'regftr.markets.accepting': "O InCrowd Answers no momento está aceitando:",
    'regftr.peers.title': "Colegas",
    'regftr.peers.subtitle': "Compare suas respostas com respostas dos colegas e aprenda com as respostas deles.",
    'regftr.invites.title': "Convites",
    'regftr.invites.subtitle': "Receba novos convites para pesquisas por e-mail ou pelo telefone e aumente seus ganhos.",
    'regftr.earnings.title': "Ganhos",
    'regftr.earnings.subtitle': "Gerencia e acompanhe sua renda e informações de pagamento.",
    'regftr.stats.title': "Situação",
    'regftr.stats.subtitle': "Acesse um painel com todas as suas informações de pesquisa e informações de usuário.",

    'contextual_help.sms': "Você receberá notificações por SMS de micropesquisas abertas. Através de SMS, você entrará em pesquisas com mais rapidez e ganhará mais recompensas. Suas informações são mantidas em segredo e usadas apenas para convites de pesquisa.",
    'contextual_help.specialty': "Inclua somente as especialidades ligadas ao seu NPI, que você tenha completado seu fellowship ou áreas da medicina que encaixem na sua especialidade principal. Caso precise alterar suas especialidades futuramente, entre em contato com support@incrowdnow.com.",
    // USER
    'user(s)': "Usuário |||| Usuários",
    'user.login': "Entrar",
    'user.logout': "Sair",
    'user.register': "Registrar",
    'user.invitations': "Convites",
    'user.email': "E-mail",
    'user.pass_word': "Senha",
    'user.mobile': "Celular",
    'user.mobile.hint': "Por favor, inclua o código do país (+%{phoneCode} para %{countryName})",
    'user.title': "Título",
    'user.title_with_example': "Título (ex: Dr., Srta., Sra)",
    'user.first_name': "Primeiro Nome",
    'user.last_name': "Sobrenome",
    'user.middle_name': "Nome do Meio",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Um Usuário",
    'user.anonymous_admin': "Usuário Administrador",
    'user.dashboard': "Painel de Controle",
    'user.profile': "Perfil",
    'user.profile.picture.upload': "Enviar imagem de perfil",
    'user.profile.picture.change': "Modificar",
    'user.primary_lang': "Idioma primário",
    'user.primary_lang?': "Qual seu idioma primário?",
    'user.survey_langs?': "Que idiomas você consegue falar fluentemente?",
    'user.notify_email': "Notificar por E-mail",
    'user.notify_mobile': "Notificar por Celular",
    'user.contact_support': "Contatar Suporte",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Por favor, <entre em contato conosco>.",
    'user.profession': "Profissão",
    'user.profession?': "Qual sua profissão?",
    'user.join_now': "Junte-se Agora",
    'user.welcome_back': "Bem-vindo de Volta!",
    'user.not_a_member?': "Ainda não é membro?",
    'user.accept_terms': "Aceitar Termos",
    'user.accept_terms.yes': "Eu aceito os <terms and conditions>",
    'user.remember_me': "Lembrar meus dados neste dispositivo",
    'user.time_zone': "Fuso Horário",
    'user.payment.policy': "Toda vez que você chegar a %{currency}25 em prêmios, você poderá selecionar nossas opções de pagamento em seu perfil InCrowd. Perguntas? Fale conosco por meio da janela de conversa abaixo.",
    'user.country.live_work?': "Em que país você mora e trabalha?",
    // FORMS
    'form.button.back': "Voltar",
    'form.button.next': "Próximo",
    'form.button.cancel': "Cancelar",
    'form.button.submit': "Enviar",
    'form.button.continue': "Continuar",
    'form.button.close': "Fechar",
    'form.button.go!': "Vai!",
    'form.button.complete!': "Concluir agora!",
    'form.button.update': "Atualizar",
    'form.button.finish': "Finalizar",
    'form.button.search': "Pesquisa",
    'form.button.end': "Fim",
    'form.search.no_matches': "Nenhuma correspondência encontrada",
    'form.confirm_email': "Confirmar E-mail",
    'form.confirm_pass_word': "Confirmar Senha",
    'form.required_fields': "Campos Obrigatórios",
    'form.nothing_selected': "Nada selecionado",
    'form.confirm_field': "Confirmar %{formFieldLabel}",
    'form.choice.n/a': "N/A",
    'form.choice.yes': "Sim",
    'form.choice.no': "Não",
    'form.choice.blank_for_all': "Deixe em branco para marcar tudo",
    'form.choices.select_all': "Marcar tudo",
    'form.choices.deselect_all': "Desmarcar tudo",
    'form.field.private': "Campo privado",

    // USER ERRORS
    'user.error.dup_email': "Outro usuário já se cadastrou com este endereço de e-mail. <Fazer log-in então?>",
    'user.error.dup_sms': "Outro usuário já se registrou com o número de telefone celular fornecido",
  }
})
